import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=64dda6e8&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=64dda6e8&prod&lang=scss"
import style1 from "./Table.vue?vue&type=style&index=1&id=64dda6e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dda6e8",
  null
  
)

export default component.exports